import Vuex from 'vuex'
import * as types from '../mutation-types'
import { API } from '../../api'
import { COURSE_DATA_MANAGER } from '../../data';
export default {
    namespaced: true,
    modules: {},
    state: {
        showCataloguePopup: false,
        showCourseActPopup: false,
        courseListPageFrom: '',
        gotCourseList: false,
        courseList: [],
        courseNowPage: 0,
        curCourseInfo: {},
        curCoursePayInfo: {},
        curCoursePayBtnData: {},
        curCourseTableList: [],
        curCourseDetailInfo: {},
        curCourseVideoInfo: {},
        curCourseVideoPercentage: [],
        gotCourseRecordList: false,
        courseRecordList: [],
        courseRecordNowPage: 0,
    },
    mutations: {
        [types.COURSE_INIT_LIST](state, params) {
            console.log('COURSE_INIT_LIST-----', params);
            function getData() {
                return new Promise((resolve, reject) => {
                    API.getCourseList({
                        "page": state.courseNowPage
                    }, function (data) {
                        // 记录列表数据轮询拉取
                        if(data.info.length > 0 && state.courseNowPage <= data.pageInfo.totalpage){
                            var resultData = COURSE_DATA_MANAGER.getCourseListByList(data.info, params);
                            state.courseList = state.courseList.concat(resultData);
                            console.log('课程列表数据------', state.courseList);
                            if(state.courseNowPage == data.pageInfo.totalpage) {
                                state.gotCourseList = true;
                            }
                        }else {
                            state.gotCourseList = true;
                            console.log("已经拉取完了", state.courseNowPage);
                        }
                        resolve();
                    });
                }).catch((err) => {
                    console.error("课程列表数据失败::::::", err);
                });
            }
            // 轮询
            function start() {
                async function timeFn () {
                    if(state.gotCourseList) {
                        return;
                    }
                    state.courseNowPage++;
                    await getData().then(function() {
                        setTimeout(timeFn, 20)
                    });
                }
                timeFn()
            }
            start();
        },
        [types.COURSE_INIT_RECORD_LIST](state, params) {
            console.log('COURSE_INIT_RECORD_LIST-----', params);
            function getData() {
                return new Promise((resolve, reject) => {
                    API.getCourseRecordList({
                        "page": state.courseRecordNowPage
                    }, function (data) {
                        // 记录列表数据轮询拉取
                        if(data.info.length > 0 && state.courseRecordNowPage <= data.pageInfo.totalpage){
                            var resultList = COURSE_DATA_MANAGER.getCourseRecordListByList(data.info);
                            state.courseRecordList = state.courseRecordList.concat(resultList);
                            console.log('课程学习列表数据------', state.courseRecordList);
                            if(state.courseRecordNowPage == data.pageInfo.totalpage) {
                                state.gotCourseRecordList = true;
                            }
                        }else {
                            state.gotCourseRecordList = true;
                            console.log("已经拉取完了", state.courseRecordNowPage);
                        }
                        resolve();
                    });
                }).catch((err) => {
                    console.error("课程学习列表数据失败::::::", err);
                });
            }
            // 轮询
            function start() {
                async function timeFn () {
                    if(state.gotCourseRecordList) {
                        return;
                    }
                    state.courseRecordNowPage++;
                    await getData().then(function() {
                        setTimeout(timeFn, 20)
                    });
                }
                timeFn()
            }
            start();
        }
    },
    actions: {
        initCourseList({ commit }, params) {
            commit(types.COURSE_INIT_LIST, params);
        },
        getCourseTableList({ state }, params ) {
            if(!params || !params.cid) {
                return;
            }

            API.getCourseCatalogueList({
                cid: params.cid
            }, (data) => {
                console.log('获取课程信息成功------', data, params.vip);
                state.curCourseInfo = data && data.info ? COURSE_DATA_MANAGER.getCourseInfoByData(data.info) : state.curCourseInfo;
                state.curCourseInfo = Object.assign({ needBuy: data.needBuy }, state.curCourseInfo);
                state.curCoursePayInfo = data && data.pay ? COURSE_DATA_MANAGER.getCoursePayInfoByData(data.pay) : Object.assign({
                    ratePrice: parseInt(data.rate_price/1000)
                });
                state.curCoursePayBtnData = data && data.pay ? COURSE_DATA_MANAGER.getCoursePayBtnDataByData(params.cid, params.vip) : {};
                console.log('curCoursePayBtnData----', state.curCoursePayBtnData, (data && data.pay), params.cid, params.vip)
                let tempList = data && data.list ? COURSE_DATA_MANAGER.getCourseTableListByList(data.list) : [];
                state.curCourseTableList = state.curCourseTableList.concat(tempList);
                console.log(state.curCourseInfo, state.curCoursePayInfo, state.curCourseTableList);

                if(params && params.sucCb && typeof(params.sucCb) == 'function') {
                    params.sucCb();
                }
            });
        },
        getCourseDetailInfo({ state }, params ) {
            if(!params || !params.dId) {
                return;
            }
            console.log('getCourseDetailInfo------', params.dId);

            API.getCourseInfo({
                id: params.dId
            }, (data) => {
                console.log('获取课程章节详情成功-------', data);
                state.curCourseDetailInfo = COURSE_DATA_MANAGER.getCourseDetailInfoByData(data.info);
                state.curCourseVideoInfo = Object.assign({playAuth: data.playAuth, videoId: data.videoId});
                // 直接查看
                if(params && params.sucCb && typeof(params.sucCb) == 'function') {
                    params.sucCb();
                }
            })
        },
        initCourseRecordList({ commit }, params) {
            commit(types.COURSE_INIT_RECORD_LIST);
        },
        updateCourseVideoPercentage({ state }, params) {
            if(state.curCourseVideoPercentage.indexOf(params.percentage) >= 0) {
                return;
            }
            API.upCourseInfo({
                id: state.curCourseDetailInfo.id,
                percentage: params.percentage
            }, (data)=> {
                console.log('上报成功----', params.percentage, state.curCourseVideoPercentage);
                state.curCourseVideoPercentage.push(params.percentage);
            })
        },
        useCourseKeyCode({ state }, params) {
            console.log('useCourseKeyCode-----', params);
            API.useCourseCode({
                cid: params.cid,
                code: params.code
            }, (data) => {
                console.log('兑换课程成功-----', data);
                // 直接查看
                if(params && params.sucCb && typeof(params.sucCb) == 'function') {
                    params.sucCb();
                }
            })

        },
        checkVipCourseStatus({ state }, params) {
            let configData = params && params.configData ? params.configData : {};
            switch(params.userVip) {
                case 10:
                    state.showCourseActPopup = !configData['course_privilege_h5_month'];
                    break;
                case 20:
                    state.showCourseActPopup = !configData['course_privilege_h5_year'];
                    break;
                case 30:
                    state.showCourseActPopup = !configData['course_privilege_h5_forever'];
                    break;
                default:
                    break;
            }
        },
        resetCourseListData({ state }) {
            state.gotCourseList = false;
            state.courseList = [];
            state.courseNowPage = 0;
        },
        resetCourseDetailData({ state }) {
            state.curCourseInfo = {};
            state.curCoursePayInfo = {};
            state.curCoursePayBtnData = [];
            state.curCourseTableList = [];
            state.curCourseDetailInfo = {};
        },
        resetCourseRecordData({ state }) {
            state.gotCourseRecordList = false;
            state.courseRecordList = [];
            state.courseRecordNowPage = 0;
        },
        resetCourseVideoInfo({ state }) {
            state.curCourseVideoInfo = {};
            state.curCourseVideoPercentage = [];
        }
    }
}
